interface AvailableTranslations {
  [key: string]: Translation
}

interface Translation {
  translateTo: string
  translatedTo: string
  wasThisTranslationHelpful: string
  giveFeedback: string
  translationFeedbackLink: string
  viewOriginal: string
  originalContent: OriginalContent
}

interface OriginalContent {
  [key: string]: string
  en: string
  es: string
  pt: string
  ko: string
}

const availableTranslations: AvailableTranslations = {
  en: {
    translateTo: 'Translate to English',
    translatedTo: 'Translated to English',
    wasThisTranslationHelpful: 'Was this translation helpful?',
    giveFeedback: 'Give Feedback',
    translationFeedbackLink: 'https://github.com/github/feedback/discussions/4373',
    viewOriginal: 'View original',
    originalContent: {
      en: 'Original comment in English',
      es: 'Original comment in Spanish',
      pt: 'Original comment in Portuguese',
      ko: 'Original comment in Korean',
    },
  },
  es: {
    translateTo: 'Traducir al español',
    translatedTo: 'Traducido al español',
    wasThisTranslationHelpful: '¿Fue útil esta traducción?',
    giveFeedback: 'Envía tus comentarios',
    translationFeedbackLink: 'https://github.com/github/feedback/discussions/6534',
    viewOriginal: 'Ver original',
    originalContent: {
      en: 'Comentario original en inglés',
      es: 'Comentario original en español',
      pt: 'Comentario original en portugués',
      ko: 'Comentario original en coreano',
    },
  },
  pt: {
    translateTo: 'Traduzir para português',
    translatedTo: 'Traduzido para o português',
    wasThisTranslationHelpful: 'Esta tradução foi útil?',
    giveFeedback: 'Dê sua opinião',
    translationFeedbackLink: 'https://github.com/github/feedback/discussions/4374',
    viewOriginal: 'Ver original',
    originalContent: {
      en: 'Comentário original em inglês',
      es: 'Comentário original em espanhol',
      pt: 'Comentário original em português',
      ko: 'Comentário original em coreano',
    },
  },
  ko: {
    translateTo: '한국어로 번역',
    translatedTo: '한국어로 번역',
    wasThisTranslationHelpful: '이 번역이 도움이 되셨나요?',
    giveFeedback: '피드백 제공',
    translationFeedbackLink: 'https://github.com/github/feedback/discussions/4372',
    viewOriginal: '원본 보기',
    originalContent: {
      en: '영어로 된 원본 주석',
      es: '스페인어로 된 원본 주석',
      pt: '포르투갈어로 된 원본 주석',
      ko: '한국어로 된 원본 주석',
    },
  },
}

export {availableTranslations}
